import { useState, useEffect, useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { WarningAmber } from '@mui/icons-material'
import PautaGroupSlider from '../../components/pauta-detail/PautaGroupSlider'
import PautaItemHeader from '../../components/pauta-detail/PautaItemHeader'
import PautaItemRow from '../../components/pauta-detail/PautaItemRow'
import { usePautaFiltering } from '../../hooks/usePautaFiltering'
import { usePautaItemActions } from '../../hooks/usePautaItemActions'
import { useProcessedPautaItems } from '../../hooks/useProcessedPautaItems' // Import the new hook
import { BacklogMessageDialog, LoadingLogoDialog, ReportDataDialog } from '../../dialogs'
import { useAuth, useConnectionContext, useExecutionReportContext, useUser, useMasterData } from '../../context'
import './pautaDetail.css'

const PautaDetail = ({ height, reportAssigned, getPautaProgreso, canEdit, filterData, report }) => {
    const { isOnline } = useConnectionContext()
    const { userData } = useAuth()
    const { isOperator, isSapExecutive, isShiftManager, isChiefMachinery, admin, isUniversalInspector, isUniversalChief } = useUser()
    const { unidades } = useMasterData()
    const { puedeTerminarJornada, executionReport, contentData, setContentData, saveItem, setIndexGroup, indexGroup } = useExecutionReportContext()

    const canSaveDialogData = canEdit && (isOperator || isSapExecutive || isShiftManager || isChiefMachinery || admin || isUniversalInspector || isUniversalChief) && report?.state === 'En proceso'

    const [opened, setOpened] = useState(true)
    // Pestañas
    const [gruposKeys, setGruposKeys] = useState([])
    // Lista de checks
    const [checks, setChecks] = useState([])
    // Indice de la actividad
    const [indexActivity, setIndexActivity] = useState()
    //
    const [indexContent, setIndexContent] = useState(0)

    const [loadingLogo, setLoadingLogo] = useState(false)
    const [revision, setRevision] = useState(false)

    const filterItem = usePautaFiltering(filterData)

    const currentGroupItems = useMemo(() => {
        if (!executionReport || !executionReport.group || !indexGroup) return []
        const group = executionReport.group[indexGroup] || []
        return group
            .map((item, idx) => ({ ...item, originalIndex: idx }))
            .filter(filterItem)
    }, [executionReport, indexGroup, filterItem])

    const processedContentData = useProcessedPautaItems(currentGroupItems, unidades) // Apply the hook to derived items

    const totalTasksCount = useMemo(() => {
        if (!executionReport || !executionReport.group || typeof executionReport.group !== 'object') return 0
        return Object.values(executionReport.group).reduce((acc, items) => {
            return acc + (Array.isArray(items) ? items.length : 0)
        }, 0)
    }, [executionReport])

    useEffect(() => {
        if (totalTasksCount === 0 && getPautaProgreso) {
            getPautaProgreso({
                progressPage: 0,
                globalProgress: 0
            })
        }
    }, [totalTasksCount, getPautaProgreso])

    useEffect(() => {
        setContentData(currentGroupItems)
    }, [currentGroupItems, setContentData])

    // usePautaItemActions hook
    const {
        item,
        index,
        openDialog1,
        openDialogBacklog,
        openItemDialog,
        openItemBacklogMessage,
        closeItemDialog,
        closeItemBacklogDialog,
        changeItemState
    } = usePautaItemActions(report, canEdit, setIndexActivity)

    const removeLogo = () => {
        setLoadingLogo(false)
    }

    /* useEffect(() => {
        setContentDataCache(contentData)
    }, [contentData]) */

    useEffect(() => {
        console.log('PautaDetail useEffect: executionReport is', executionReport)
        if (revision) {
            setRevision(false)
        } else {
            const newGroupData = []
            if (executionReport && executionReport._id && executionReport.group && typeof executionReport.group === 'object') {
                Object.keys(executionReport.group).forEach((data) => {
                    let tieneBacklog = false
                    const groupItems = executionReport.group[data] || []

                    if (Array.isArray(groupItems)) {
                        const hasMatchingItems = groupItems.some(item => filterItem(item))

                        if (hasMatchingItems) {
                            groupItems.forEach((d) => {
                                if (d && d.backlogList && d.backlogList.length > 0) {
                                    tieneBacklog = true
                                }
                            })
                            const tab = {
                                data: data,
                                state: false,
                                tieneBacklog: tieneBacklog
                            }
                            newGroupData.push(tab)
                        }
                    }
                })

                if (newGroupData.length > 0) {
                    let newIndex = 0
                    let selectedDataName = indexGroup

                    const foundIndex = newGroupData.findIndex(g => g.data === indexGroup)

                    if (foundIndex !== -1) {
                        newIndex = foundIndex
                    } else {
                        newIndex = 0
                        selectedDataName = newGroupData[0].data
                    }

                    newGroupData[newIndex].state = true
                    setIndexGroup(selectedDataName)
                    setIndexContent(newIndex)
                } else {
                    setIndexContent(0)
                }

                setGruposKeys((report && report.testMode) ? [newGroupData[0], newGroupData[1], newGroupData[2]].filter(Boolean) : newGroupData)
            }
        }
    }, [executionReport, revision, filterItem, filterData, report])

    useEffect(() => {
        if (executionReport && executionReport._id && executionReport.group && typeof executionReport.group === 'object' && unidades.length > 0) {
            const contentDataGlobal = []
            const checkedGlobal = []

            Object.values(executionReport.group).forEach((contentDataGroup) => {
                if (Array.isArray(contentDataGroup)) {
                    contentDataGroup.forEach((item) => {
                        contentDataGlobal.push(item)
                        if (item && (item.isChecked || item.isWarning)) {
                            checkedGlobal.push(item)
                        }
                    })
                }
            })

            const currentGroupItems = executionReport.group[indexGroup] || []
            const checkedInPage = currentGroupItems.filter(item => item && (item.isChecked || item.isWarning)).length
            const progressPage = currentGroupItems.length > 0 ? ((checkedInPage * 100) / currentGroupItems.length).toFixed(0) : 0
            const globalProgress = contentDataGlobal.length > 0 ? ((checkedGlobal.length * 100) / contentDataGlobal.length).toFixed(0) : 0

            getPautaProgreso({
                progressPage: isNaN(progressPage) ? 0 : progressPage,
                globalProgress: isNaN(globalProgress) ? 0 : globalProgress
            })

            if (!openDialog1) {
                setOpened(false)
            }
        }
    }, [processedContentData, executionReport, indexGroup, unidades, getPautaProgreso, openDialog1])

    const handleContent = (i, element) => {
        setIndexContent(i)
        setIndexGroup(element)
        const groupsItem = []
        // Fix: Use element key to access group data safely
        if (executionReport && executionReport.group && executionReport.group[element]) {
            executionReport.group[element].forEach((item, idx) => {
                if (filterItem(item)) {
                    groupsItem.push({ ...item, originalIndex: idx })
                }
            })
        }
        setContentData(groupsItem)
        /* setContentDataCache(Object.values(executionReport.group)[i]) */
        const keysCache = [...gruposKeys]
        keysCache.forEach(key => {
            key.state = false
        })
        if (keysCache[i]) {
            keysCache[i].state = true
        }
        setGruposKeys(keysCache)
    }

    if (totalTasksCount === 0) {
        return (
            <div style={{ width: '100%', padding: '24px 12px' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: { xs: 2.5, sm: 4 },
                        my: 2,
                        mx: 'auto',
                        maxWidth: 620,
                        borderRadius: 3,
                        backgroundColor: '#fff',
                        border: '1.5px solid #fed7aa',
                        boxShadow: '0 4px 14px rgba(245, 158, 11, 0.08)',
                        textAlign: 'center'
                    }}
                >
                    <Box
                        sx={{
                            width: 64,
                            height: 64,
                            borderRadius: '50%',
                            backgroundColor: '#fff7ed',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 2,
                            border: '1px solid #ffedd5'
                        }}
                    >
                        <WarningAmber sx={{ fontSize: 36, color: '#f59e0b' }} />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#9a3412', mb: 1, fontSize: '1.15rem' }}>
                        No existe la guía de ejecuciones para esta pauta
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#7c2d12', mb: 2.5, lineHeight: 1.6, px: 1 }}>
                        Esta orden de trabajo no cuenta con una estructura de actividades ni tareas asociadas en el sistema.<br/>Comuniquese con <strong>Administración</strong>.
                    </Typography>
                    <Box
                        sx={{
                            display: 'inline-flex',
                            flexWrap: 'wrap',
                            gap: 1.5,
                            justifyContent: 'center',
                            p: 1.2,
                            borderRadius: 1.5,
                            backgroundColor: '#fef3c7',
                            border: '1px solid #fde68a'
                        }}
                    >
                        {report?.sapId && (
                            <Typography variant="caption" sx={{ color: '#92400e', fontWeight: 600 }}>
                                SAP: {report.sapId}
                            </Typography>
                        )}
                        {(report?.idPm || report?.idpm) && (
                            <Typography variant="caption" sx={{ color: '#92400e', fontWeight: 600 }}>
                                • SPM: {report.idPm || report.idpm}
                            </Typography>
                        )}
                        {report?.guide && (
                            <Typography variant="caption" sx={{ color: '#92400e', fontWeight: 600 }}>
                                • Guía: {report.guide}
                            </Typography>
                        )}
                        {report?.machine && (
                            <Typography variant="caption" sx={{ color: '#92400e', fontWeight: 600 }}>
                                • Equipo: {report.machine}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </div>
        )
    }

    return (
        <div style={{ width: '100%' }}>
            {openDialogBacklog && <BacklogMessageDialog
                open={openDialogBacklog}
                itemReport={item} // Use item directly from hook
                close={closeItemBacklogDialog} // Use from hook
                index={index}
                report={report}
            />}
            <PautaGroupSlider
                gruposKeys={gruposKeys}
                handleContent={handleContent}
                indexContent={indexContent}
                testMode={report && report.testMode}
            />
            {report && <div style={{ position: 'relative' }}>
                <PautaItemHeader report={report} />
                <div style={{ height: height, overflowY: 'auto' }}>
                    {
                        processedContentData.length > 0 ? (
                            processedContentData.map((e, n) => ( // Use processedContentData
                                <PautaItemRow
                                    key={`${indexGroup}-${n}`}
                                    item={e}
                                    index={e.originalIndex !== undefined ? e.originalIndex : n}
                                    report={report}
                                    isOperator={isOperator}
                                    userData={userData}
                                    puedeTerminarJornada={puedeTerminarJornada}
                                    indexGroup={indexGroup}
                                    openDialog={openItemDialog} // Use from hook
                                    openBacklogMessage={openItemBacklogMessage} // Use from hook
                                    changeState={changeItemState} // Use from hook
                                    canEdit={canEdit}
                                    isOnline={isOnline}
                                />
                            ))
                        ) : (
                            <div style={{ textAlign: 'center', padding: '30px 10px', color: '#888' }}>
                                <p style={{ fontSize: 14, margin: 0 }}>
                                    No hay actividades para mostrar en este grupo con los filtros actuales.
                                </p>
                            </div>
                        )
                    }
                </div>
                {openDialog1 && <ReportDataDialog
                    open={openDialog1}
                    handleClose={closeItemDialog} // Use from hook
                    report={reportAssigned}
                    item={item}
                    index={index}
                    executionReport={executionReport}
                    gruposKeys={gruposKeys}
                    indexActivity={indexActivity}
                    indexGroup={indexGroup}
                    save={saveItem}
                    setChecks={setChecks}
                    canEdit={canSaveDialogData}
                />}
                {
                    loadingLogo &&
                    <div>
                        <LoadingLogoDialog open={loadingLogo} />
                        <div style={{ width: '100%', position: 'absolute', left: 0, bottom: 50, textAlign: 'center' }}>
                            <button onClick={removeLogo}>CANCELAR</button>
                        </div>
                    </div>
                }
            </div>}
        </div>
    )
}

export default PautaDetail
